/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import QRCode from 'react-qr-code';
import { useParams } from 'react-router-dom';
import mask from 'slim-mask-js';
import { LoadManager, PageContainer } from '~/components';
import useAxiosRequest from '~/hooks/useAxiosRequest.1';
import usePageTitle from '~/hooks/usePageTitle';
import dateMask from '~/lib/masks/date';
import documentNumberMask from '~/lib/masks/documentNumber';
import thumbor from '~/lib/thumbor';
import prescritions from '~/services/prescritions';

const Show: React.FC<{title: string}> = ({ title }) => {
  usePageTitle({ title });

  const { id, clinicalCareUid } = useParams();

  const { status, error, data } = useAxiosRequest(prescritions.show, clinicalCareUid, id);
  const { clinic, animal } = data?.clinicalCare || {};

  return (
    <PageContainer gridSize="grid-md">
      <LoadManager apiStatus={status} error={error}>
        <div className="prescrition-border p-relative p-2">
          <div className="columns align-center">
            <div className="column col-auto">
              <div className="column col-auto">
                <figure className="avatar avatar-xl" data-initial={clinic?.fullName?.[0]}>
                  <img
                    src="/logo192.png"
                    alt="Logo Petis"
                  />
                </figure>
              </div>

            </div>
            <div className="column text-center">
              <div className="h5">Receita veterinária</div>
            </div>
            <div className="column col-auto">
              <QRCode value={window.location.href} size={70} />
            </div>
          </div>
          <div className="divider" />
          <div className="columns align-center my-2 py-2 px-1 mx-1">
            <div className="column col-auto">
              <figure className="avatar avatar-lg" data-initial={clinic?.fullName?.[0]}>
                {
                  Boolean(clinic?.photoURL)
                  && (
                    <img
                      src={thumbor(clinic?.photoURL, { width: 64, height: 64 })}
                      alt="Avatar da pessoa"
                    />
                  )
                }
              </figure>
            </div>
            <div className="column">
              <div>
                Clínica:
                {' '}
                <b>
                  {documentNumberMask(clinic?.documentNumber)}
                  {' '}
                  -
                  {' '}
                  {clinic?.fullName}
                </b>
              </div>
              <div>
                Receita emitida em:
                {' '}
                <b>
                  {dateMask(data?.createdAt, { hour: '2-digit', minute: '2-digit' })}
                </b>
              </div>
            </div>
          </div>
          <div className="divider" />
          <small>
            <table className="table">
              <thead>
                <tr>
                  <th>Dados do animal</th>
                  <th />
                  <th />
                  <th />
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <small>Nome</small>
                    <div>
                      <b>{animal?.name}</b>
                    </div>
                  </td>
                  <td>
                    <small>RGA</small>
                    <div>
                      <b>{mask(animal?.uid, '####.####.####.####.####')}</b>
                    </div>
                  </td>
                  <td>
                    <small>Data de nascimento</small>
                    <div>
                      <b>{dateMask(animal?.bornedAt)}</b>
                    </div>
                  </td>
                  <td>
                    <small>Espécie/Raça</small>
                    <div>
                      <b>
                        {animal?.category?.description}
                        {' '}
                        -
                        {' '}
                        {animal?.breed?.description}
                      </b>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </small>
          <div>
            <div className="h6 my-2 text-center ">Medicamentos/Orientações</div>
            {data?.data?.map((item: {name: string; dosage: string; uid:string}) => (
              <div
                className="my-2"
                style={{
                  lineHeight: 1, borderLeft: '1px solid #ccc', paddingLeft: 5,
                }}
                key={item?.uid}
              >
                <div>{item?.name}</div>
                <div>
                  <small>
                    Dosagem:
                    {' '}
                    <b>{item?.dosage}</b>
                  </small>
                </div>
              </div>
            ))}
          </div>
          <div className="p-absolute" style={{ bottom: 20, right: 10 }}>
            ______________________________
            <div className="text-center">
              {clinic?.fullName}
            </div>
          </div>
          <button
            type="button"
            className="btn btn-link no-print p-absolute"
            style={{ bottom: 0, left: 0 }}
            onClick={() => window.print()}
          >
            <i className="fas fa-print" />
            &nbsp;Imprimir receita
          </button>
        </div>
      </LoadManager>
    </PageContainer>
  );
};

export default Show;
